import BankIcon from "@mui/icons-material/AccountBalanceOutlined";
import type { SxProps, Theme } from "@mui/material";
import { Avatar, Box, Divider, Paper, Stack, Typography } from "@mui/material";
import LimitedListWithBadge from "@entrilia/shared/components/LimitedListWithBadge";
import ShowMoreLessButton from "@entrilia/shared/components/ShowMoreLessButton";
import useToggleState from "@entrilia/shared/hooks/useToggleState";
import { distinct } from "@entrilia/shared/utilities/arrayHelper";
import type { InvestorBankAccountDetails } from "../../../../api/types/bankAccountTypes";
import BankAccountDetailsTable from "./BankAccountDetailsTable";

interface Props {
  bankAccount: InvestorBankAccountDetails;
  sx?: SxProps<Theme>;
}

const BankAccountCard = ({ bankAccount, sx }: Props) => {
  const [expanded, toggleExpanded] = useToggleState(false);

  return (
    <Paper variant="outlined" sx={{ px: 2, ...sx }}>
      <Stack direction="row" spacing={1.5} sx={{ py: 1.5 }}>
        <Avatar variant="rounded" sx={{ width: 40, height: 40, bgcolor: "background.grey" }}>
          <BankIcon />
        </Avatar>
        <Stack spacing={0.5}>
          <Typography variant="subtitle1">{bankAccount.description}</Typography>
          <Typography variant="caption" color="textSecondary">
            {bankAccount.accountName}
          </Typography>
        </Stack>
      </Stack>
      <Divider sx={{ borderStyle: "dashed" }} />
      <Stack spacing={1.5} sx={{ pt: 1.5, pb: 2 }}>
        <Typography variant="subtitle1">Bank Details</Typography>
        {expanded && <BankAccountDetailsTable bankAccount={bankAccount} />}
      </Stack>
      <Divider sx={{ borderStyle: "dashed" }} />
      <Box sx={{ py: 1.5 }}>
        <LimitedListWithBadge
          title="Fund Assignments"
          items={distinct(bankAccount.fundNames)}
          maxVisibleItems={5}
          itemTypographyProps={{ variant: "caption", sx: { color: "text.secondary" } }}
          expanded={expanded}
        />
      </Box>
      <Divider sx={{ borderStyle: "dashed" }} />
      <Box sx={{ py: 1 }}>
        <ShowMoreLessButton expanded={expanded} onClick={() => toggleExpanded()} />
      </Box>
    </Paper>
  );
};

export default BankAccountCard;
